import React, {FC, useEffect} from 'react';
import {useAction} from "../../../../../store/hooks/useAction";
import {useTypedSelector} from "../../../../../store/hooks/useTypedSelector";
import {Accordion} from "react-bootstrap";
import {Link} from "react-router-dom";

interface STLProps {
    atagParams: string | null
    viewType?: string | null
    eventKey: string
    ticketOpenMode: string | null
    sourceParams: string | null,
}
const QuicktipLobbyWidget: FC <STLProps> = ({atagParams, viewType,ticketOpenMode,eventKey, sourceParams}) => {
    const {getQuicktipsData} = useAction();
    const {quicktipsData} = useTypedSelector((state) => state.quicktipsReducer);
    const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;
    useEffect(()=>{
        getQuicktipsData();
    }, [])
    return(
        <>
            {quicktipsData.length > 0 ?
                <Accordion.Item eventKey={eventKey} className='cursor-pointer'>
                    <Accordion.Header>Quicktip</Accordion.Header>
                    <Accordion.Body>
                        <ul
                            style={{
                                listStyle: 'none',
                                padding: '0'
                            }}
                        >
                            {
                                quicktipsData.length > 0 ?
                                    quicktipsData.map((item: any, index: number) => {
                                        return (
                                            <li key={`${index}quicktipData`} className='mt-1'>
                                                <Link
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'left',
                                                        alignItems: ' center'
                                                    }}
                                                    to={(() => {
                                                        let url = `quicktip/${item.code}`;
                                                        const params = new URLSearchParams();

                                                        if (atagParams) params.append('atag', atagParams);
                                                        if (sourceParams) params.append('source', sourceParams);
                                                        if (viewType) params.append('viewType', viewType);
                                                        const queryString = params.toString();
                                                        if (queryString) url += `?${queryString}`;

                                                        return url;
                                                    })()}
                                                    className='smartbet-card-link text-decoration-none  sidebar-ticket-link'
                                                    target={ticketOpenMode === 'redirect' ? '_blank' : undefined}
                                                >
                                                    <img
                                                        src={`${item.preview_img}`}
                                                        onError={(e) => {
                                                            e.currentTarget.src = toAbsoluteUrl('/assets/img/events/league/F2964C.png');
                                                        }}
                                                        width='35'
                                                        height='35'
                                                        alt="QBX-logo"
                                                        style={{
                                                            borderRadius: "1rem"
                                                        }}
                                                    />
                                                    <div style={{marginLeft: '10px'}}
                                                         className='text-center text-green'>
                                                        {item.title.length > 0 ? item.title : null}
                                                    </div>
                                                </Link>
                                            </li>
                                        )
                                    }) : null
                            }
                        </ul>
                    </Accordion.Body>
                </Accordion.Item>
                : null
            }
        </>
    )

}

export default QuicktipLobbyWidget;
